export default "__VITE_ASSET__Cb454Z5$__"